const { getElements } = window.BAO.Utils

export class ShadeFilterItem extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.setupClickListeners()
  }

  setupShadeItems (shadeGroupNameHandle) {
    // Get all colour shade elements
    const shades = document.querySelectorAll('[data-shade-groups]')

    // Iterate through each shade
    shades.forEach(shade => {
      // Get the data-shade-groups attribute and split it into an array
      const colors = shade.getAttribute('data-shade-groups').split(',')

      // Check if the colors array includes the shadeGroupNameHandle
      if (colors.includes(shadeGroupNameHandle)) {
        // If it matches, show it
        shade.parentElement.setAttribute('aria-hidden', 'false')

        // Count the number of 'shade' elements with aria-hidden false
        const visibleShadesCount = document.querySelectorAll('.prd-DetailVariants_Option-radio[aria-hidden="false"]').length

        // Update counter for visible shades
        document.querySelector('[data-shade-counter]').innerHTML = visibleShadesCount
      } else {
        // If it doesn't match, hide it
        shade.parentElement.setAttribute('aria-hidden', 'true')
      }
    })
  }

  // Function to attach event listeners to all matching triggers
  setupClickListeners () {
    // Get all triggers that could potentially change div opacities
    const triggers = getElements('[data-filter-shade-group]')

    // Iterate through each trigger
    triggers.forEach(trigger => {
      // Add click event listener to each trigger
      trigger.addEventListener('click', function () {
        // Remove 'selected' attribute from all triggers
        triggers.forEach((t) => {
          t.removeAttribute('selected')
        })
        // Set 'selected' attribute on the clicked trigger
        this.setAttribute('selected', '')

        // Get the data-filter-shade-group attribute value from the clicked trigger
        const shadeGroupNameHandle = this.getAttribute('data-filter-shade-group')

        // Update label for visible shades
        const shadeGroupName = this.innerHTML
        document.querySelector('[data-shade-title]').innerHTML = shadeGroupName

        // Update the swatch visibility
        this.setupShadeItems(shadeGroupNameHandle)
      })
    })
  }
}

if (!customElements.get('shade-filter-item')) {
  customElements.define('shade-filter-item', ShadeFilterItem)
}
